import { createApiInstance } from './ApiConfig';

// Create axios instance with base configuration
const api = createApiInstance();

// OTA Device Management APIs

export const listOtaDevices = async () => {
  return api.get('/ota/devices');
};

export const setDeviceOta = async (
  serialNumber,
  { target_version, binary_filename, autorestart }
) => {
  const formData = new FormData();
  if (target_version) {
    formData.append('target_version', target_version);
  }
  if (binary_filename) {
    formData.append('binary_filename', binary_filename);
  }
  formData.append('autorestart', autorestart);

  return api.post(`/ota/devices/${serialNumber}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteDeviceOta = async serialNumber => {
  return api.delete(`/ota/devices/${serialNumber}`);
};

// Binary Management APIs

export const listBinaries = async () => {
  return api.get('/ota/binaries');
};

export const uploadBinary = async (file, filename, versionString, onUploadProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  if (filename) {
    formData.append('filename', filename);
  }
  formData.append('version_string', versionString);

  return api.post('/ota/binaries/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const downloadBinary = async filename => {
  return api.get(`/ota/binaries/${filename}`, {
    responseType: 'blob',
  });
};

export const deleteBinary = async filename => {
  return api.delete(`/ota/binaries/${filename}`);
};

export const renameBinary = async (oldFilename, newFilename) => {
  const formData = new FormData();
  formData.append('new_filename', newFilename);

  return api.put(`/ota/binaries/${oldFilename}/rename`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Changelog APIs

export const getChangelog = async () => {
  return api.get('/ota/changelog');
};

export const saveChangelog = async (content, append = false) => {
  const formData = new FormData();
  formData.append('content', content);

  return api.post(`/ota/changelog?append=${append}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
